var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":'cart.delete_selection',"description":"cart.are_you_sure_you_want_to_remove_these_products"},on:{"confirm":function($event){return _vm.$emit('confirmDelete')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-delete',{attrs:{"size":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }